// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"8e3ded60","453":"65e4c3cd","796":"d86ee77c"}[chunkId] + ".chunk.js";
};